import { Flex, Skeleton } from '@raystack/apsara';

import { For, Show } from '@src/hoc';

import styles from './loaders.module.css';

const MessageItem = ({ isAssistant = false }) => {
  return (
    <Flex className='fullWidth' align='start' justify='start' gap={3}>
      <Skeleton enableAnimation={false} height={16} width={16} />
      <Flex className='fullWidth' direction='column' align='start' gap={5}>
        <Skeleton height={16} width={240} />
        <Show when={isAssistant}>
          <Skeleton height={24} width={300} />
          <Skeleton height={32} width={320} />
        </Show>
      </Flex>
    </Flex>
  );
};

export const MessagesSkeleton = ({ count = 2 }) => {
  return (
    <For each={Array.from({ length: count }) as number[]}>
      {(d: number) => (
        <Flex className={styles.wrapper} direction='column' gap={9} key={d}>
          <MessageItem /> <MessageItem isAssistant />
        </Flex>
      )}
    </For>
  );
};

export const PromptsSkeleton = () => {
  const PROMPTS_PROPS = [
    { height: 20, width: 260 },
    { height: 20, width: 320 },
    { height: 30, width: 340 },
    { height: 20, width: 360 },
    { height: 20, width: 280 },
    { height: 20, width: 240 }
  ];
  return (
    <Flex direction='column' align='start' gap={5}>
      <For each={PROMPTS_PROPS}>
        {(props, i) => <Skeleton key={i} {...props} />}
      </For>
    </Flex>
  );
};

export const HistoryItemSkeleton = () => {
  return (
    <Flex
      className={styles.historyWrapper}
      direction='column'
      justify='start'
      gap={5}
    >
      <Skeleton height={16} width={200} />
      <Skeleton height={16} width={300} />
    </Flex>
  );
};
